import type { ReactNode } from 'react';
import { Icon } from '@/components/Icon';
import './credential-banner.css';

/**
 * One row of the shell's banner strip about a mailbox's password: the
 * sentence, the one action that fixes it, and a dismiss for this page load.
 *
 * Shared by the withdrawn-background-password notice (#210) and the
 * can't-sign-in notice (#192), so the two read and behave as one strip rather
 * than two inventions stacked on each other.
 */
export function NoticeRow({
  label,
  children,
  action,
  dismissLabel,
  onDismiss,
}: {
  /** The row's accessible name: the sentence's gist, naming the mailbox. */
  label: string;
  children: ReactNode;
  action: ReactNode;
  dismissLabel: string;
  onDismiss: () => void;
}) {
  return (
    <div className="credential-banner" role="status" aria-label={label}>
      <span className="credential-banner__text">{children}</span>
      {action}
      <button
        type="button"
        className="btn btn--icon credential-banner__dismiss"
        aria-label={dismissLabel}
        onClick={onDismiss}
      >
        <Icon name="close" size={16} />
      </button>
    </div>
  );
}
